import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Booking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedOnward, selectedReturn, tripType } = location.state || {};

  const chosenFlight = selectedOnward;

  if (!selectedOnward && !selectedReturn) {
    return (
      <div className="no-flight">
        <h3>No flight selected!</h3>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  // ✅ Handle Form Submit (same as before)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const payload = {
      tripType: tripType || "oneway",
      onwardFlight: selectedOnward || {},
      returnFlight: tripType === "round trip" ? selectedReturn || {} : null,
      ResultIndex: chosenFlight?.ResultIndex || "",
      EndUserIp: "192.168.11.58",
      TokenId: "2abbe90b-7984-4442-a96a-cd7d32554076",
      TraceId: chosenFlight?.TraceId || "",

      passenger: {
        Title: form.title.value,
        FirstName: form.firstName.value,
        LastName: form.lastName.value,
        Gender: form.gender.value,
        PaxType: "1",
        DateOfBirth: form.dob.value || null,
        PassportNo: form.passportNo.value || null,
        PassportExpiry: form.passportExpiry.value || null,
        AddressLine1: form.address1.value,
        AddressLine2: form.address2.value || "",
        City: form.city.value,
        CountryCode: form.countryCode.value,
        CountryName: form.countryName.value,
        Nationality: form.nationality.value,
        CellCountryCode: form.cellCountryCode.value || "+91",
        ContactNo: form.contactNo.value,
        Email: form.email.value,
        IsLeadPax: true,
      },

      Fare: chosenFlight?.Fare || {},
      Meal: chosenFlight?.Meal || [],
      Seat: chosenFlight?.Seat || [],
    };

    console.log("✅ Sending Payload to Laravel:", payload);

    try {
      const response = await fetch("https://online.funforay.com/admin/api/book-flight", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("✅ Booking response:", result);
    } catch (error) {
      console.error("❌ Error sending booking:", error);
    }
  };

  // 🧭 For multicity, flatten all segments
  const multiSegments =
    tripType === "multicity" ? selectedOnward?.Segments?.flat() || [] : [];

  // ✅ Fare calculation
  const onwardFare = selectedOnward?.Fare || {};
  const returnFare = selectedReturn?.Fare || {};
  const isRoundTrip = tripType === "round trip";

  const totalBaseFare =
    (onwardFare.BaseFare || 0) + (isRoundTrip ? returnFare.BaseFare || 0 : 0);
  const totalTax =
    (onwardFare.Tax || 0) + (isRoundTrip ? returnFare.Tax || 0 : 0);
  const totalPublishedFare =
    (onwardFare.PublishedFare || 0) +
    (isRoundTrip ? returnFare.PublishedFare || 0 : 0);

  return (
    <div className="booking-wrapper">
      <div className="booking-container">
        {/* LEFT SECTION */}
        <div className="booking-left">
          
          <div className="flight-summary">
            <div className="flight-header">
              <div>
                <h3>
                  {tripType === "multicity"
                    ? "Multi-City Trip"
                    : `${selectedOnward?.Segments?.[0]?.[0]?.Origin?.Airport?.CityName || "N/A"} → ${
                        selectedOnward?.Segments?.[0]?.slice(-1)[0]?.Destination?.Airport?.CityName || "N/A"
                      }`}
                </h3>
                <p>
                  {tripType === "round trip"
                    ? "Round Trip"
                    : tripType === "multicity"
                    ? "Multiple Cities"
                    : "One Way"}{" "}
                  | Economy
                </p>
              </div>
              <div className="flight-price">
                ₹
                {Math.round(totalPublishedFare || 0).toLocaleString("en-IN")}
              </div>
            </div>

            {/* Multicity Segments */}
            {tripType === "multicity" ? (
              <div className="multicity-list">
                {multiSegments.map((seg, i) => (
                  <div key={i} className="multi-seg-card">
                    <p>
                      <b></b>{" "}
                      {seg.Origin?.Airport?.CityName} ({seg.Origin?.Airport?.AirportCode}) →
                      {seg.Destination?.Airport?.CityName} ({seg.Destination?.Airport?.AirportCode})
                    </p>
                    <p>
                      ⏰ Departure:{" "}
                      {new Date(seg.Origin?.DepTime).toLocaleString("en-GB")}
                    </p>
                    <p>
                      🛬 Arrival:{" "}
                      {new Date(seg.Destination?.ArrTime).toLocaleString("en-GB")}
                    </p>
                    <hr />
                  </div>
                ))}
              </div>
            ) : (
              <>
                <div className="flight-timing">
                  <span>
                    🛫 {selectedOnward?.Segments?.[0]?.[0]?.Origin?.Airport?.CityName} (
                    {selectedOnward?.Segments?.[0]?.[0]?.Origin?.Airport?.AirportCode})
                  </span>
                  <span>→</span>
                  <span>
                    🛬 {selectedOnward?.Segments?.[0]?.slice(-1)[0]?.Destination?.Airport?.CityName} (
                    {selectedOnward?.Segments?.[0]?.slice(-1)[0]?.Destination?.Airport?.AirportCode})
                  </span>
                </div>
                {tripType === "round trip" && selectedReturn && (
                  <div className="return-flight">
                    🔁 Return:{" "}
                    {selectedReturn.Segments?.[0]?.[0]?.Origin?.Airport?.CityName} →{" "}
                    {selectedReturn.Segments?.[0]?.slice(-1)[0]?.Destination?.Airport?.CityName} | ₹
                    {Math.round(selectedReturn.Fare?.PublishedFare || 0).toLocaleString("en-IN")}
                  </div>
                )}
              </>
            )}
          </div>

          {/* BOOKING FORM */}
          <form className="formdesign-class" onSubmit={handleSubmit}>
            <div style={{ marginBottom: "1rem" }}>
              <select name="title" required style={{ width: "100%", padding: "0.5rem" }}>
                <option value="">Select (Mr, Ms, Mrs)</option>
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
                <option value="Mrs">Mrs</option>
              </select>
            </div>

            <input name="firstName" type="text" placeholder="First Name" required style={inputStyle} />
            <input name="lastName" type="text" placeholder="Last Name" required style={inputStyle} />

            <select name="gender" required style={inputStyle}>
              <option value="">Select Gender</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>

            <label>Date of Birth (Optional)</label>
            <input name="dob" type="date" style={inputStyle} />

            <input name="email" type="email" placeholder="Email" required style={inputStyle} />
            <input name="passportNo" type="text" placeholder="Passport No" style={inputStyle} />

            <input name="address1" type="text" placeholder="Address Line 1" required style={inputStyle} />
            <input name="address2" type="text" placeholder="Address Line 2" style={inputStyle} />
            <input name="city" type="text" placeholder="City" required style={inputStyle} />

            <input name="countryCode" type="text" placeholder="Country Code" defaultValue="IN" required style={inputStyle} />
            <input name="countryName" type="text" placeholder="Country Name" defaultValue="India" required style={inputStyle} />

            <label>Passport Expiry</label>
            <input name="passportExpiry" type="date" style={inputStyle} />

            <input name="cellCountryCode" type="text" placeholder="Cell Country Code" defaultValue="+91" style={inputStyle} />
            <input name="contactNo" type="tel" placeholder="Contact No" required style={inputStyle} />
            <input name="nationality" type="text" placeholder="Nationality" defaultValue="IN" required style={inputStyle} />

            <button type="submit" className="btn btn-primary" style={{ width: "94%" }}>
              Confirm Booking
            </button>
          </form>
        </div>

        {/* ✅ RIGHT SECTION — Updated Fare Summary */}
        <div className="booking-right">
          <div className="fare-summary">
            <h4>Fare Summary</h4>

            {/* Onward Fare */}
            <div className="fare-section">
              <h5>Onward Flight</h5>
              <div className="fare-row">
                <span>Base Fare</span>
                <span>₹{(onwardFare.BaseFare || 0).toLocaleString("en-IN")}</span>
              </div>
              <div className="fare-row">
                <span>Taxes & Fees</span>
                <span>₹{(onwardFare.Tax || 0).toLocaleString("en-IN")}</span>
              </div>
              <div className="fare-row subtotal">
                <span>Subtotal</span>
                <span>₹{Math.round(onwardFare.PublishedFare || 0).toLocaleString("en-IN")}</span>
              </div>
            </div>

            {/* Return Fare (only for round trip) */}
            {isRoundTrip && selectedReturn && (
              <div className="fare-section">
                <h5>Return Flight</h5>
                <div className="fare-row">
                  <span>Base Fare</span>
                  <span>₹{(returnFare.BaseFare || 0).toLocaleString("en-IN")}</span>
                </div>
                <div className="fare-row">
                  <span>Taxes & Fees</span>
                  <span>₹{(returnFare.Tax || 0).toLocaleString("en-IN")}</span>
                </div>
                <div className="fare-row subtotal">
                  <span>Subtotal</span>
                  <span>₹{Math.round(returnFare.PublishedFare || 0).toLocaleString("en-IN")}</span>
                </div>
              </div>
            )}

            <hr />
            {/* Total Combined Fare */}
            <div className="fare-row total">
              <span>Total</span>
              <span>₹{Math.round(totalPublishedFare || 0).toLocaleString("en-IN")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ✅ Input Style
const inputStyle = {
  width: "100%",
  padding: "0.5rem",
  marginBottom: "0.8rem",
  border: "1px solid #ccc",
  borderRadius: "4px",
};

export default Booking;
